export const SKILLS_ORDER_OPTIONS = Object.freeze({
  by_count: {label: 'Sort by most scores', value: 'BY_SCORES_COUNT'},
  by_name: {label: 'Sort alphabetically', value: 'BY_NAME'},
});
